import { UsersRoundIcon } from "lucide-react";
// import Razorpay from "razorpay";
import {
  getCategories,
  getNavMenu,
  getParentCategoryName,
  getProducts,
  getCompanyInfo,
  sendOtp,
  resendOtp,
  verifyOtp,
  saveUserAddress,
  getProDetail,
  setDefaultAdd,
  getUserProfileData,
  updateUserProfileData,
  uploadUserImageData,
  addToCartData,
  getCartData,
  deleteFromCartData,
  saveOrder,
  saveOrdMaster,
  getDiscount,
  razorPay_Order,
  getUserShipments,
  getUserOrders,
  cancelUserOrder,
  razorPay_verifyPayment,
  razorPay_paymentFailed,
  adminLogin,
  verifyAdminToken,
  getAdminCategories,
  createCategory,
  updateCategory,
  deleteCategory,
  getAdminUsers,
  createAdminUser,
  changeAdminPassword,
  getAdminSellers,
  getAdminProducts,
  getAdminProductDetail,
  createAdminProduct,
  updateAdminProduct,
  deleteAdminProduct,
  deleteAdminProductImage,
  exportAdminAvailQty,
  importAdminAvailQty,
  getAdminOrders,
  getAdminOrderDetails,
  getAdminOrderCustomer,
  getAdminCustomers,
  getAdminCustomerAddresses,
  getAdminCategorySales,
  getAdminParentCategories,
  createAdminParentCategory,
  updateAdminParentCategory,
  deleteAdminParentCategory,
  getAdminShipments,
  createAdminShipment,
  updateAdminShipment,
  getAdminDiscounts,
  createAdminDiscount,
  updateAdminDiscount,
  deleteAdminDiscount,
  getAdminGstRate,
  updateAdminGstRate,
  getPublicGstRate,
  getShippingProviders,
  getAdminShippingOptions,
  createAdminShippingOption,
  updateAdminShippingOption,
  deleteAdminShippingOption,
  setDefaultAdminShippingOption,
  getPublicShippingOption,
  calculateShippingCharge,
} from "./api";

export const getSeedCategories = async (lng) => {
  return getCategories(lng);
};

export const getParentCategory_Name = async (pcId, lng) => {
  return getParentCategoryName(pcId, lng);
};

export const getNav_Menu = async (lng) => {
  return getNavMenu(lng);
};

// export const getAllProducts = async (lng) => {
//   return getProducts(lng);
// };

export const getAllProducts = async (params) => {
  return getProducts(params);
};

export const getCompany_Info = async (lng) => {
  return getCompanyInfo(lng);
};

export const send_Otp = async (phone) => {
  return sendOtp(phone);
};

export const resend_Otp = async (phone) => {
  return resendOtp(phone);
};

export const verify_Otp = async (phone, otp) => {
  return verifyOtp(phone, otp);
};

export const saveUser_Address = async (formData, userId) => {
  return saveUserAddress(formData, userId);
};

export const getProductDetail = async (productId) => {
  return getProDetail(productId);
};

export const setDefaultAddress = async (addressId, userId) => {
  return setDefaultAdd(addressId, userId);
};

export const getUserProfile = async (mobileNo) => {
  return getUserProfileData(mobileNo);
};

export const updateUserProfile = async (mobileNo, name, email) => {
  return updateUserProfileData(mobileNo, name, email);
};

export const uploadUserImage = async (userId, file) => {
  return uploadUserImageData(userId, file);
};

export const addToCart_Data = async (formData, userId) => {
  return addToCartData(formData, userId);
};

export const getCart_Data = async (userId, lng) => {
  return getCartData(userId, lng);
};

export const deleteFromCart_Data = async (formData, userId) => {
  return deleteFromCartData(formData, userId);
};

export const saveOrder_Data = async (formData, userId, localOrderId) => {
  return saveOrder(formData, userId, localOrderId);
};

export const saveOrder_Master = async (userId, totals, discount, addressId, shippingCharge, shippingProvider) => {
  return saveOrdMaster(userId, totals, discount, addressId, shippingCharge, shippingProvider);
};

export const getDiscount_Data = async (couponCode, orderTotal) => {
  return getDiscount(couponCode, orderTotal);
};

export const generateRazorPay_Order = async (totals, localOrderId) => {
  return razorPay_Order(totals, localOrderId);
};

export const getShipments = async (userId) => {
  return getUserShipments(userId);
};

export const getOrders = async () => {
  return getUserOrders();
};

export const cancelOrder = async (orderId) => {
  return cancelUserOrder(orderId);
};

export const rPay_verifyPayment = async (
  razorpayIds,
  cartItems,
  localOrderId,
  amount,
) => {
  return razorPay_verifyPayment(razorpayIds, cartItems, localOrderId, amount);
};

export const rPay_paymentFailed = async (localOrderId) => {
  console.log("localorderId", localOrderId);
  return razorPay_paymentFailed(localOrderId);
};

export const admin_Login = async (username, password) => {
  return adminLogin(username, password);
};

export const verify_Admin_Token = async () => {
  return verifyAdminToken();
};

export const getAdmin_Categories = async () => {
  return getAdminCategories();
};

export const createAdmin_Category = async (formData) => {
  return createCategory(formData);
};

export const updateAdmin_Category = async (id, formData) => {
  return updateCategory(id, formData);
};

export const deleteAdmin_Category = async (id) => {
  return deleteCategory(id);
};

export const getAdmin_Users = async () => {
  return getAdminUsers();
};

export const createAdmin_User = async (payload) => {
  return createAdminUser(payload);
};

export const changeAdmin_Password = async (id, payload) => {
  return changeAdminPassword(id, payload);
};

export const getAdmin_Sellers = async () => {
  return getAdminSellers();
};

export const getAdmin_Products = async () => {
  return getAdminProducts();
};

export const getAdmin_ProductDetail = async (id) => {
  return getAdminProductDetail(id);
};

export const createAdmin_Product = async (formData) => {
  return createAdminProduct(formData);
};

export const updateAdmin_Product = async (id, formData) => {
  return updateAdminProduct(id, formData);
};

export const deleteAdmin_Product = async (id) => {
  return deleteAdminProduct(id);
};

export const deleteAdmin_ProductImage = async (id, imageId) => {
  return deleteAdminProductImage(id, imageId);
};

export const exportAdmin_AvailQty = async (sellerId) => {
  return exportAdminAvailQty(sellerId);
};

export const importAdmin_AvailQty = async (formData) => {
  return importAdminAvailQty(formData);
};

export const getAdmin_Orders = async () => {
  return getAdminOrders();
};

export const getAdmin_OrderDetails = async (orderId) => {
  return getAdminOrderDetails(orderId);
};

export const getAdmin_OrderCustomer = async (userId, addressId) => {
  return getAdminOrderCustomer(userId, addressId);
};

export const getAdmin_CategorySales = async () => {
  return getAdminCategorySales();
};

export const getAdmin_ParentCategories = async () => {
  return getAdminParentCategories();
};

export const createAdmin_ParentCategory = async (payload) => {
  return createAdminParentCategory(payload);
};

export const updateAdmin_ParentCategory = async (pcId, payload) => {
  return updateAdminParentCategory(pcId, payload);
};

export const deleteAdmin_ParentCategory = async (pcId) => {
  return deleteAdminParentCategory(pcId);
};

export const getAdmin_Customers = async () => {
  return getAdminCustomers();
};

export const getAdmin_CustomerAddresses = async (userId) => {
  return getAdminCustomerAddresses(userId);
};

// ── Shipments ────────────────────────────────────────────────────────────────
export const getAdmin_Shipments = async () => {
  return getAdminShipments();
};

export const createAdmin_Shipment = async (payload) => {
  return createAdminShipment(payload);
};

export const updateAdmin_Shipment = async (id, payload) => {
  return updateAdminShipment(id, payload);
};

// ── Discount Coupons ─────────────────────────────────────────────────────────
export const getAdmin_Discounts = async () => {
  return getAdminDiscounts();
};

export const createAdmin_Discount = async (payload) => {
  return createAdminDiscount(payload);
};

export const updateAdmin_Discount = async (id, payload) => {
  return updateAdminDiscount(id, payload);
};

export const deleteAdmin_Discount = async (id) => {
  return deleteAdminDiscount(id);
};

// ── GST Settings ─────────────────────────────────────────────────────────────
export const getAdmin_GstRate = async () => {
  return getAdminGstRate();
};

export const updateAdmin_GstRate = async (gst_percentage) => {
  return updateAdminGstRate(gst_percentage);
};

export const getPublic_GstRate = async () => {
  return getPublicGstRate();
};

// ── Shipping ──────────────────────────────────────────────────────────────────
export const get_ShippingProviders = async () => getShippingProviders();
export const getAdmin_ShippingOptions = async () => getAdminShippingOptions();
export const createAdmin_ShippingOption = async (p) => createAdminShippingOption(p);
export const updateAdmin_ShippingOption = async (id, p) => updateAdminShippingOption(id, p);
export const deleteAdmin_ShippingOption = async (id) => deleteAdminShippingOption(id);
export const setDefault_ShippingOption = async (id) => setDefaultAdminShippingOption(id);
export const getPublic_ShippingOption = async () => getPublicShippingOption();
export const calculate_ShippingCharge = async (items, pincode) => calculateShippingCharge(items, pincode);

